// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--kzy_0{color:currentColor}.box--jwERn{stroke:currentColor}.strap--VQgJC{stroke:#00a555}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/Nav/Package/index.module.scss"],"names":[],"mappings":"AAAA,aAAM,kBAAkB,CAAC,YAAK,mBAAmB,CAAC,cAAO,cAAc","sourcesContent":[".icon{color:currentColor}.box{stroke:currentColor}.strap{stroke:#00a555}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--kzy_0",
	"box": "box--jwERn",
	"strap": "strap--VQgJC"
};
export default ___CSS_LOADER_EXPORT___;
